import { OverviewFormValues } from './types';

export const deviceTypeOptions = [
  { label: '新', value: 1 },
  { label: '旧', value: 2 },
];

export const specOptions = [
  { label: '100', value: 100 },
  { label: '115', value: 115 },
  { label: '180', value: 180 },
  { label: '210', value: 210 },
];

export const deviceTypeLabelMap: Record<number, string> = {
  1: '新',
  2: '旧',
};

export const mainConfigList = [1, 2, 3] as const;
export const stationConfigList = [1, 2, 3, 4] as const;
export const DEFAULT_OVERVIEW_TITLE = '空压机总览';
export const MAX_OVERVIEW_TITLE_LENGTH = 20;

export const mainDeviceKeyMap = {
  1: 'mainDevice1',
  2: 'mainDevice2',
  3: 'mainDevice3',
} as const;

export const mainThresholdKeyMap = {
  1: 'mainThreshold1',
  2: 'mainThreshold2',
  3: 'mainThreshold3',
} as const;

export const stationKeyMap = {
  1: 'station1',
  2: 'station2',
  3: 'station3',
  4: 'station4',
} as const;

export const branchPipeKeyMap = {
  1: 'branchPipe1',
  2: 'branchPipe2',
  3: 'branchPipe3',
  4: 'branchPipe4',
} as const;

export const stationStatusKeyMap = {
  1: 'stationStatus1',
  2: 'stationStatus2',
  3: 'stationStatus3',
  4: 'stationStatus4',
} as const;

export const getInitialFormValues = (): OverviewFormValues => ({
  title: DEFAULT_OVERVIEW_TITLE,
  mainDevice1: undefined,
  mainThreshold1: undefined,
  mainDevice2: undefined,
  mainThreshold2: undefined,
  mainDevice3: undefined,
  mainThreshold3: undefined,
  station1: undefined,
  station2: undefined,
  station3: undefined,
  station4: undefined,
  branchPipe1: [],
  branchPipe2: [],
  branchPipe3: [],
  branchPipe4: [],
  stationStatus1: undefined,
  stationStatus2: undefined,
  stationStatus3: undefined,
  stationStatus4: undefined,
});
